if (!customElements.get('ia-simple-atc')) {
  class IaSimpleAtc extends HTMLElement {
    connectedCallback() {
      this.variantId = parseInt(this.dataset.variantId, 10)
      this.btn = this.querySelector('button')
      if (!this.btn || !this.variantId) return
      this.btn.addEventListener('click', this.handleClick.bind(this))
    }

    async handleClick() {
      if (this.btn.disabled) return
      this.btn.disabled = true

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest',
          },
          body: JSON.stringify({ items: [{ id: this.variantId, quantity: 1 }] }),
        })

        if (!response.ok) {
          const err = await response.json().catch(() => ({}))
          console.error('ia-simple-atc: cart/add.js failed', err)
        }
      } catch (err) {
        console.error('ia-simple-atc: fetch error', err)
      }

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cartdrawer:refresh'))
        window.timber?.RightDrawer?.open?.()
        this.btn.disabled = false
      }, 400)
    }
  }

  customElements.define('ia-simple-atc', IaSimpleAtc)
}
